import React, { useContext, useEffect, useState } from "react"
import { Link } from "gatsby-plugin-intl"
import Logo_en from "../images/logo-en.png"
// import Logo_en_ from "../images/logo-en_.png"
import Logo_zh from "../images/logo-zh.png"
// import Logo_zh_ from "../images/logo-zh_.png"
import "./header.sass"
import classNames from "classnames"
import { defaultIntl, EventBus, window, _isMobile } from "../utils"
import Country from "./country"
import Language from "./language"
import { globalContext } from "./context"

const Logo = ({ intl = defaultIntl, invert }) => {
  const $src = intl.locale === "zh" ? Logo_zh : Logo_en
  return <img className="logo" src={$src} alt={intl.formatMessage({ id: "global.logo_alt" })} />
}

const Menu = () => {
  const { intl } = useContext(globalContext)
  const linkToJob = `${window.origin}/${intl?.locale}/jobs/`
  return (
    <>
      <Link to="/partner/" className="navbar-item">
        {intl.formatMessage({ id: "global.menu.partner" })}
      </Link>
      <Link to="/driver/" className="navbar-item">
        {intl.formatMessage({ id: "global.menu.driver" })}
      </Link>
      <a href={linkToJob} className="navbar-item">
        {intl.formatMessage({ id: "global.menu.career" })}
      </a>
    </>
  )
}

const Header = ({ intl = defaultIntl, page }) => {
  const [invert, setInvert] = useState(false)
  const [showMenu, setShowMenu] = useState(false)
  const isMobile = _isMobile()
  let unsubscribe
  useEffect(() => {
    if (page === "index") {
      unsubscribe = EventBus.subscribe(e => {
        const state = EventBus.getState()
        setInvert(state.invert)
      })
    } else {
      setInvert(true)
    }
    return () => {
      unsubscribe && unsubscribe()
    }
  }, [])

  return (
    <div className={classNames("navbar is-fixed-top", { invert })}>
      <div className="container">
        {isMobile ? (
          <>
            <div className="navbar-brand">
              <div className="brand" onClick={() => setShowMenu(!showMenu)}>
                <span />
                <span />
                <span />
              </div>
              {showMenu && (
                <div className="dropdown-menu-list">
                  <Menu />
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="navbar-brand">
            <Link to="/">
              <Logo intl={intl} invert={invert} />
            </Link>
          </div>
        )}
        <div className="navbar-list">
          {!isMobile && <Menu />}
          <Language />
          <Country />
        </div>
      </div>
    </div>
  )
}
export default Header
